module.exports = __webpack_public_path__ + "img/nav_mobil_banner_fruehling_V2.5627971.jpg";